export const listConstants = {
  mobileList: 'mobileList',
  mobileMap: 'mobileMap',
};
